import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500 text-sm">
        Loading workspace…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  // Force password change for first login OR 30-day expiry
  if (user.password_change_required && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  if (roles && roles.length > 0 && user.role !== "super_admin" && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
